import React, { useState, useEffect } from 'react';
import styles from './valider.module.css';
import soumettre3 from "../../assets/icons/Vérifier et soumettre-3.png"
import { auth, db } from '../../firebase/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

function Valider({ prescriptionData, patientDetails, onModify, userRole }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [effectiveUserRole, setEffectiveUserRole] = useState(userRole);

  /*console.log("Full prescription data in Valider:", prescriptionData);
  console.log("Special instructions:", prescriptionData?.specialInstructions);
  console.log("Prescription data received:", prescriptionData);
  console.log("Patient details received in Valider:", patientDetails);
  console.log("User role received in Valider:", userRole);
  console.log("Espacement data:", prescriptionData ? {
    espacement: prescriptionData.espacement,
    especesSpecifiques: prescriptionData.especesSpecifiques,
    expansion: prescriptionData.expansion,
    expansion2: prescriptionData.expansion2,
    vestibuloversion: prescriptionData.vestibuloversion,
    vestibuloversion2: prescriptionData.vestibuloversion2,
    ripAnt: prescriptionData.ripAnt,
    ripAnt2: prescriptionData.ripAnt2,
    ripPostDroite: prescriptionData.ripPostDroite,
    ripPostDroite2: prescriptionData.ripPostDroite2,
    ripPostGauche: prescriptionData.ripPostGauche,
    ripPostGauche2: prescriptionData.ripPostGauche2,
    extractions: prescriptionData.extractions,
    extractionsTeeth: prescriptionData.extractionsTeeth
  } : "No prescription data");*/
     
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
        setCurrentUser(user);
        if (user) {
            try {
                // Create a query to find the medecin document with matching email
                const medecinsRef = collection(db, 'medecins');
                const q = query(medecinsRef, where('email', '==', user.email));
                const querySnapshot = await getDocs(q);
                
                if (!querySnapshot.empty) {
                    // Get the first matching document
                    const userDoc = querySnapshot.docs[0];
                    setEffectiveUserRole(userDoc.data().role);
                    /*console.log("User role:", userDoc.data().role); // Debug log*/
                } else {
                    /*console.log("No medecin found with email:", user.email);*/
                }
            } catch (error) {
                /*console.error("Error fetching user role:", error);*/
            }
        }
    });

    return () => unsubscribe();
  }, []);
  
  if (!prescriptionData) {
    return (
      <div className={styles.formStep}>
        <div className={styles.sectionHeader}>
          <h2>Vérification de la prescription</h2>
          <img src={soumettre3} alt="details"/>
        </div>
        <div className={styles.scrollableContent}>
          <div className={styles.soumettre}>
            <div>Aucune donnée de prescription disponible. Veuillez compléter les étapes précédentes.</div>
          </div>
        </div>
      </div>
    );
  }

  const handleModifyPrescription = (section) => {
    // Always pass step 4 (prescription step) and the section name
    onModify(4, section);
  };

  const formatArcadeText = () => {
    if (prescriptionData.arcade === 'both') {
      return 'Les deux arcades';
    } else if (prescriptionData.arcade === 'maxillaire') {
      const option = prescriptionData.maxillaireOption;
      return `Maxillaire${option ? ` (Arcade opposée: ${
        option === 'rien' ? 'Rien' : 
        option === 'diagnostic' ? 'Diagnostic' : 
        option === 'aligners' ? 'Aligners passifs' : ''
      })` : ''}`;
    } else if (prescriptionData.arcade === 'mandibulaire') {
      const option = prescriptionData.mandibulaireOption;
      return `Mandibulaire${option ? ` (Arcade opposée: ${
        option === 'rien' ? 'Rien' : 
        option === 'diagnostic' ? 'Diagnostic' : 
        option === 'aligners' ? 'Aligners passifs' : ''
      })` : ''}`;
    }
    return 'Non spécifié';
  };

  const formatTeethNumbers = (teeth) => {
    if (!teeth || teeth.length === 0) return 'Aucune dent sélectionnée';
    return teeth.sort().join(', ');
  };

  const formatRapportAP = () => {
    const rapportAP = prescriptionData.rapportAP;
    const text = [];

    if (rapportAP.D) {
      text.push(`Côté Droit: ${formatRapportAPOption(rapportAP.D)}`);
    }
    if (rapportAP.G) {
      text.push(`Côté Gauche: ${formatRapportAPOption(rapportAP.G)}`);
    }

    if (rapportAP.rip) {
      text.push(`RIP postérieure${rapportAP.ripPrecision ? ` (${rapportAP.ripPrecision})` : ''}`);
    }
    if (rapportAP.simulation) {
      text.push(`Simulation${rapportAP.simulationPrecision ? ` (${rapportAP.simulationPrecision})` : ''}`);
    }
    if (rapportAP.chirurgie) {
      text.push('Option chirurgicale');
    }

    return text.join('\n');
  };

  const formatRapportAPOption = (option) => {
    switch (option) {
      case 'conserver': return 'Conserver la situation actuelle';
      case 'ameliorer_canine': return 'Améliorer la relation canine uniquement';
      case 'ameliorer_both': return 'Améliorer la relation canine & molaire';
      case 'correction': return 'Correction en Classe I';
      default: return option;
    }
  };

  const formatEspacementText = (prescriptionData) => {
    let text = [];

    // Add main espacement choice
    if (prescriptionData.espacement) {
      if (prescriptionData.espacement === 'fermer') {
        text.push("Fermer tous les espaces");
      } else if (prescriptionData.espacement === 'laisser') {
        text.push("Laisser des espaces spécifiques");
        if (prescriptionData.especesSpecifiques) {
          text.push(`Détails: ${prescriptionData.especesSpecifiques}`);
        }
      }
    }

    // Add maxillaire resolution details if any maxillaire data exists
    if (prescriptionData.expansion || prescriptionData.vestibuloversion || 
        prescriptionData.ripAnt || prescriptionData.ripPostDroite || prescriptionData.ripPostGauche) {
      text.push("\nRésolution au maxillaire:");
      if (prescriptionData.expansion) {
        text.push(`- Expansion: ${prescriptionData.expansion}`);
      }
      if (prescriptionData.vestibuloversion) {
        text.push(`- Vestibuloversion: ${prescriptionData.vestibuloversion}`);
      }
      if (prescriptionData.ripAnt) {
        text.push(`- RIP - Antérieure: ${prescriptionData.ripAnt}`);
      }
      if (prescriptionData.ripPostDroite) {
        text.push(`- RIP - Postérieure à droite: ${prescriptionData.ripPostDroite}`);
      }
      if (prescriptionData.ripPostGauche) {
        text.push(`- RIP - Postérieure à gauche: ${prescriptionData.ripPostGauche}`);
      }
    }

    // Add mandibulaire resolution details if any mandibulaire data exists
    if (prescriptionData.expansion2 || prescriptionData.vestibuloversion2 || 
        prescriptionData.ripAnt2 || prescriptionData.ripPostDroite2 || prescriptionData.ripPostGauche2) {
      text.push("\nRésolution à la mandibulaire:");
      if (prescriptionData.expansion2) {
        text.push(`- Expansion: ${prescriptionData.expansion2}`);
      }
      if (prescriptionData.vestibuloversion2) {
        text.push(`- Vestibuloversion: ${prescriptionData.vestibuloversion2}`);
      }
      if (prescriptionData.ripAnt2) {
        text.push(`- RIP - Antérieure: ${prescriptionData.ripAnt2}`);
      }
      if (prescriptionData.ripPostDroite2) {
        text.push(`- RIP - Postérieure à droite: ${prescriptionData.ripPostDroite2}`);
      }
      if (prescriptionData.ripPostGauche2) {
        text.push(`- RIP - Postérieure à gauche: ${prescriptionData.ripPostGauche2}`);
      }
    }

    // Add extractions information if present
    if (prescriptionData.extractions) {
      text.push("\nExtractions:");
      if (prescriptionData.extractions === 'none') {
        text.push("Aucune extraction");
      } else if (prescriptionData.extractions === 'some') {
        text.push("Extraire les dents suivantes:");
        if (prescriptionData.extractionsTeeth && prescriptionData.extractionsTeeth.length > 0) {
          text.push(`Dents sélectionnées: ${prescriptionData.extractionsTeeth.join(', ')}`);
        }
      }
    }

    return text.join('\n') || "Aucune information d'espacement spécifiée";
  };

  // Check if user role is orthodontiste - normalize the case and check for substring
  const isOrthodontiste = effectiveUserRole && 
    (effectiveUserRole.toLowerCase() === 'orthodontiste' || 
     effectiveUserRole.toLowerCase().includes('ortho'));
  
  // If userRole is undefined, check if we should default to orthodontiste (can be set to false to change default behavior)
  const defaultToOrthodontiste = true;
  const effectiveIsOrthodontiste = effectiveUserRole ? isOrthodontiste : defaultToOrthodontiste;
  
  /*console.log("Is orthodontiste?", effectiveIsOrthodontiste, "User role:", effectiveUserRole || "undefined");*/

  // Helper to get full label for Overjet
  const getOverjetLabel = (value) => {
    switch (value) {
      case 'realiser':
        return "Réaliser les autres objectifs et j'évaluerai le surplomb";
      case 'maintenir':
        return "Maintenir le surplomb d'origine (IPR peut être nécessaire)";
      case 'ameliorer':
        return "Améliorer le surplomb créé par IPR";
      default:
        return value || 'Non spécifié';
    }
  };

  // Helper to get full label for Overbite
  const getOverbiteLabel = (value) => {
    switch (value) {
      case 'realiser':
        return "Réaliser les autres objectifs et j'évaluerai le recouvrement";
      case 'maintenir':
        return "Maintenir le recouvrement d'origine (IPR peut être nécessaire)";
      case 'corriger_beance':
        return "Corriger la béance";
      case 'corriger_supraclusion':
        return "Corriger la supraclusion";
      default:
        return value || 'Non spécifié';
    }
  };

  // Helper to get full label for Milieux
  const getMilieuxLabel = (value) => {
    switch (value) {
      case 'realiser':
        return "Réaliser les autres objectifs et j'évaluerai les milieux inter-incisifs";
      case 'maintenir':
        return "Maintenir les milieux inter-incisifs d'origine (IPR peut être nécessaire)";
      case 'ameliorer':
        return "Améliorer les milieux inter-incisifs par IPR";
      default:
        return value || 'Non spécifié';
    }
  };

  return (
    <div className={styles.formStep}>
      <div className={styles.sectionHeader}>
        <h2>Vérification de la prescription</h2>
        <img src={soumettre3} alt="details"/>
      </div>
      
      <div className={styles.scrollableContent}>
        <div className={styles.soumettre}>
          <h1>Patient: {patientDetails?.nom || ''} {patientDetails?.prenom || ''}</h1>

          <div className={styles.sec}>
            <div className={styles.secHeader}>
              <h2>1.Arcade(s) à traiter</h2>
              <button className={styles.modifier} onClick={() => handleModifyPrescription('arcade')}>Modifier</button>
            </div>
            <div>{formatArcadeText()}</div>
          </div>

          <div className={styles.sec}>
            <div className={styles.secHeader}>
              <h2>2.Restrictions des mouvements dentaires</h2>
              <button  className={styles.modifier} onClick={() => handleModifyPrescription('restrictions')}>Modifier</button>
            </div>
            <div>
              {prescriptionData.restrictions === 'none' ? 'Aucune restriction - Déplacer toutes les dents' :
               prescriptionData.restrictions === 'some' ? `Ne pas déplacer: ${formatTeethNumbers(prescriptionData.restrictionsTeeth)}` :
               'Non spécifié'}
            </div>
          </div>

          <div className={styles.sec}>
            <div className={styles.secHeader}>
              <h2>3.Taquets</h2>
              <button className={styles.modifier} onClick={() => handleModifyPrescription('taquets')}>Modifier</button>
            </div>
            <div>
              {prescriptionData.taquets === 'none' ? 'Placer des taquets si nécessaire' :
               prescriptionData.taquets === 'some' ? `Ne pas placer de taquets sur: ${formatTeethNumbers(prescriptionData.taquetsTeeth)}` :
               'Non spécifié'}
            </div>
          </div>

          {effectiveIsOrthodontiste ? (
            <>
              <div className={styles.sec}>
                <div className={styles.secHeader}>
                  <h2>4.Rapport antéro-postérieur</h2>
                  <button className={styles.modifier} onClick={() => handleModifyPrescription('rapportAP')}>Modifier</button>
                </div>
                <div className={styles.multilineText}>{formatRapportAP()}</div>
              </div>

              <div className={styles.sec}>
                <div className={styles.secHeader}>
                  <h2>5.Overjet</h2>
                  <button className={styles.modifier} onClick={() => handleModifyPrescription('overjet')}>Modifier</button>
                </div>
                <div>{getOverjetLabel(prescriptionData.overjet)}</div>
              </div>

              <div className={styles.sec}>
                <div className={styles.secHeader}>
                  <h2>6.Overbite</h2>
                  <button className={styles.modifier} onClick={() => handleModifyPrescription('overbite')}>Modifier</button>
                </div>
                <div>
                  <div>{getOverbiteLabel(prescriptionData.overbite)}</div>
                  {prescriptionData.maxillaireOverbite?.selected && (
                    <div>
                      Maxillaire:
                      {prescriptionData.maxillaireOverbite.egressionAnterieure && <div>- Égression des dents antérieures</div>}
                      {prescriptionData.maxillaireOverbite.ingressionPosterieure && <div>- Ingression des dents postérieures</div>}
                    </div>
                  )}
                  {prescriptionData.mandibulaireOverbite?.selected && (
                    <div>
                      Mandibulaire:
                      {prescriptionData.mandibulaireOverbite.egressionAnterieure && <div>- Égression des dents antérieures</div>}
                      {prescriptionData.mandibulaireOverbite.ingressionPosterieure && <div>- Ingression des dents postérieures</div>}
                    </div>
                  )}
                </div>
              </div>

              <div className={styles.sec}>
                <div className={styles.secHeader}>
                  <h2>7.Bite Ramps</h2>
                  <button className={styles.modifier} onClick={() => handleModifyPrescription('biteRamps')}>Modifier</button>
                </div>
                <div>
                  {prescriptionData.biteRamps && (
                    <>
                      <div>{prescriptionData.biteRamps}</div>
                      {Array.isArray(prescriptionData.biteRampsOptions) && prescriptionData.biteRampsOptions.length > 0 && (
                        <div>Options: {prescriptionData.biteRampsOptions.join(', ')}</div>
                      )}
                    </>
                  )}
                </div>
              </div>

              <div className={styles.sec}>
                <div className={styles.secHeader}>
                  <h2>8.Milieux inter-incisifs</h2>
                  <button className={styles.modifier} onClick={() => handleModifyPrescription('milieux')}>Modifier</button>
                </div>
                <div>
                  {prescriptionData.milieux && (
                    <>
                      <div>{getMilieuxLabel(prescriptionData.milieux)}</div>
                      {prescriptionData.milieuxOptions && prescriptionData.milieuxOptions.length > 0 && (
                        <div>
                          {prescriptionData.milieuxOptions.includes('maxillaire') && (
                            <div>
                              Maxillaire:
                              {prescriptionData.milieuxOptions.includes('maxillaireDirection-droite') && ' vers la droite'}
                              {prescriptionData.milieuxOptions.includes('maxillaireDirection-gauche') && ' vers la gauche'}
                            </div>
                          )}
                          {prescriptionData.milieuxOptions.includes('mandibulaire') && (
                            <div>
                              Mandibulaire:
                              {prescriptionData.milieuxOptions.includes('mandibulaireDirection-droite') && ' vers la droite'}
                              {prescriptionData.milieuxOptions.includes('mandibulaireDirection-gauche') && ' vers la gauche'}
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>

              <div className={styles.sec}>
                <div className={styles.secHeader}>
                  <h2>9.Articulé croisé postérieur</h2>
                  <button className={styles.modifier} onClick={() => handleModifyPrescription('extractions')}>Modifier</button>
                </div>
                <div>
                  {prescriptionData.articule === 'none' ? 'Ne pas corriger' :
                   prescriptionData.articule === 'some' ? 'Corriger' :
                   'Non spécifié'}
                </div>
              </div>

              <div className={styles.sec}>
                <div className={styles.secHeader}>
                  <h2>10.Espacement et Encombrement (DDM)</h2>
                  <button className={styles.modifier} onClick={() => handleModifyPrescription('Espacement')}>Modifier</button>
                </div>
                <div className={styles.content}>
                  {(prescriptionData.espacement || 
                    prescriptionData.expansion || 
                    prescriptionData.expansion2 || 
                    prescriptionData.vestibuloversion ||
                    prescriptionData.vestibuloversion2 ||
                    prescriptionData.ripAnt ||
                    prescriptionData.ripAnt2 ||
                    prescriptionData.ripPostDroite ||
                    prescriptionData.ripPostDroite2 ||
                    prescriptionData.ripPostGauche ||
                    prescriptionData.ripPostGauche2 ||
                    prescriptionData.extractions) ? (
                    <pre className={styles.preformatted}>
                      {formatEspacementText(prescriptionData)}
                    </pre>
                  ) : (
                    <p>Aucune information d'espacement spécifiée</p>
                  )}
                </div>
              </div>

              <div className={styles.sec}>
                <div className={styles.secHeader}>
                  <h2>11.Instructions Spéciales</h2>
                  <button className={styles.modifier} onClick={() => handleModifyPrescription('specialInstructions')}>Modifier</button>
                </div>
                <div>
                  {typeof prescriptionData.specialInstructions === 'string' 
                    ? prescriptionData.specialInstructions 
                    : 'Aucune instruction spéciale'}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className={styles.sec}>
                <div className={styles.secHeader}>
                  <h2>4.Milieux inter-incisifs</h2>
                  <button className={styles.modifier} onClick={() => handleModifyPrescription('milieux')}>Modifier</button>
                </div>
                <div>
                  {prescriptionData.milieux && (
                    <>
                      <div>{getMilieuxLabel(prescriptionData.milieux)}</div>
                      {prescriptionData.milieuxOptions && prescriptionData.milieuxOptions.length > 0 && (
                        <div>
                          {prescriptionData.milieuxOptions.includes('maxillaire') && (
                            <div>
                              Maxillaire:
                              {prescriptionData.milieuxOptions.includes('maxillaireDirection-droite') && ' vers la droite'}
                              {prescriptionData.milieuxOptions.includes('maxillaireDirection-gauche') && ' vers la gauche'}
                            </div>
                          )}
                          {prescriptionData.milieuxOptions.includes('mandibulaire') && (
                            <div>
                              Mandibulaire:
                              {prescriptionData.milieuxOptions.includes('mandibulaireDirection-droite') && ' vers la droite'}
                              {prescriptionData.milieuxOptions.includes('mandibulaireDirection-gauche') && ' vers la gauche'}
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>

              <div className={styles.sec}>
                <div className={styles.secHeader}>
                  <h2>5.Espacement et Encombrement (DDM)</h2>
                  <button className={styles.modifier} onClick={() => handleModifyPrescription('Espacement')}>Modifier</button>
                </div>
                <div className={styles.content}>
                  {(prescriptionData.espacement || 
                    prescriptionData.expansion || 
                    prescriptionData.expansion2 || 
                    prescriptionData.vestibuloversion ||
                    prescriptionData.vestibuloversion2 ||
                    prescriptionData.ripAnt ||
                    prescriptionData.ripAnt2 ||
                    prescriptionData.ripPostDroite ||
                    prescriptionData.ripPostDroite2 ||
                    prescriptionData.ripPostGauche ||
                    prescriptionData.ripPostGauche2 ||
                    prescriptionData.extractions) ? (
                    <pre className={styles.preformatted}>
                      {formatEspacementText(prescriptionData)}
                    </pre>
                  ) : (
                    <p>Aucune information d'espacement spécifiée</p>
                  )}
                </div>
              </div>

              <div className={styles.sec}>
                <div className={styles.secHeader}>
                  <h2>6.Instructions Spéciales</h2>
                  <button className={styles.modifier} onClick={() => handleModifyPrescription('specialInstructions')}>Modifier</button>
                </div>
                <div>
                  {typeof prescriptionData.specialInstructions === 'string' 
                    ? prescriptionData.specialInstructions 
                    : 'Aucune instruction spéciale'}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Valider;